import { createFileRoute } from '@tanstack/react-router';
import { ListingDetailPage } from '@/features/public/ListingDetailPage';
import { publicHead } from '@/features/public/PublicLayout';
import { publicListingQuery } from '@/features/public/queries';

export const Route = createFileRoute('/explore/$listingId')({
  // The page reads the same query; the loader only settles it first so the head can use the title.
  loader: async ({ context: { queryClient }, params }) => {
    const query = publicListingQuery(params.listingId);
    await queryClient.prefetchQuery(query);
    return { listing: queryClient.getQueryData(query.queryKey) ?? null };
  },
  head: ({ loaderData }) =>
    loaderData?.listing
      ? publicHead(loaderData.listing.title, loaderData.listing.summary)
      : publicHead('Listing not available', 'This listing is not published.'),
  component: ListingDetailRoute,
});

function ListingDetailRoute() {
  const { listingId } = Route.useParams();
  return <ListingDetailPage slug={listingId} />;
}
